import Vue from 'vue'
import Router from 'vue-router'

import Home from '@/components/views/home'
import QuienesSomos from '@/components/views/quienes-somos'
import kitDigital from '@/components/views/kit-digital'

import Clientes from '@/components/views/clientes'
import Productos from '@/components/views/productos'
import ProductoFicha from '@/components/views/producto-ficha'

import Saladeprensa from '@/components/views/sala-de-prensa'
import features from '@/components/views/features'
import blog from '@/components/views/blog'
import fichaBlog from '@/components/views/ficha-blog'
import ebooks from '@/components/views/ebooks'
import medios from '@/components/views/medios'
import casosExito from '@/components/views/casos-exito-page'
import Contacto from '@/components/views/contacto'


import Error404 from '@/components/views/error-404'

import InvitacionWebInar from '@/components/views/invitacion-webinar'
import InvitacionWebInarBis from '@/components/views/invitacion-webinar-2'

import politicaCookies from '@/components/views/politica-de-cookies'
import politicaPrivacidad from '@/components/views/politica-de-privacidad'
import avisoLegal from '@/components/views/aviso-legal'
import demoRichiedi from '@/components/views/demo-richiedi'
import test from '@/components/views/test'

Vue.use(Router)


import messages from '@/translations';

let es = messages.es.enlaces;
let en = messages.en.enlaces;
let it = messages.it.enlaces;

import { store } from '@/store/store';

let translations = store.state.language;
translations = messages[translations];

const router = new Router({
  mode: 'history',
  routes: [{
    path: '/',
    component: Home,
    meta: {
      title: translations.metaTitle,
      description: translations.metaDescription

    }
  },
  {
    path: '/quienes-somos',
    component: QuienesSomos,
    meta: {
      title: "Iformalia | Quienes somos",
      description: "La plataforma Iformalia, desarrollada por Grupo Innopulse, es el sistema líder en gestión de la formación privada y bonificada en España."
    }
  },

  {
    path: '/kit-digital',
    component: kitDigital,
    meta: {
      title: "Iformalia | Kit Digital",
      description: "Iformalia pertenece a Grupo Innopulse, quién se ha convertido en agente digitalizador dentro del programa Kit Digital."
    }
  },
  {
    path: '/servicios',
    component: Productos,
    meta: {
      title: "Iformalia | Servicios",
      description: "Somos un ERP de gestión de formación bonificada para empresas, agencias de colocación, centros de formación, gestoras de formación o sector público."
    }
  },
  {
    path: '/productos',
    component: features,
    meta: {
      title: "Iformalia | Productos",
      description: "Iformalia, Una plataforma con amplias funcionalidades: aulas virtuales, firma digital, detección de necesidades de formación, elearning, portal de alumno y empleado, CRM comercial."
    }
  },

  {
    path: '/blog',
    component: blog,
    meta: {
      title: "Iformalia | Blogs",
      description: "Mantente al día de nuestras novedades con el Blog de Iformalia."
    }
  },
  {
    path: '/ebooks',
    component: ebooks,
    meta: {
      title: "Iformalia | Ebooks",
      description: "Entérate de todo lo que podemos hacer por tu organización a través de nuestros Ebooks."
    }
  },
  {
    path: '/medios',
    component: medios,
    meta: {
      title: "Iformalia | En los Medios",
      description: "Entérate de todo lo que hablan de nosotros los medios digitales más importantes del país y descubre que podemos hacer por tu organización."
    }
  }, {
    path: '/casos-de-exito',
    component: casosExito,
    meta: {
      title: "Iformalia | Casos de Éxito",
      description: "Descubre a través de nuestros casos de éxito como generamos valor sobre tu organización o empresa."
    }
  },
  {
    path: '/clientes',
    component: Clientes,
    meta: {
      title: "Iformalia | Clientes",
      description: "Un gran número de clientes avalan nuestra experiencia. Descubre lo que Iformalia ha hecho por sus organizaciones."
    }
  },
  {
    path: '/contacto',
    component: Contacto,
    meta: {
      title: "Iformalia | Contacto - Solicita tu Demo",
      description: "¿Quieres contactar con nosotros o solicitar una demo? Hazlo a través de nuestro formulario o llamando al 911427887."
    }
  },
  {
    path: '/invitacion-webinar',
    component: InvitacionWebInar,
    name: 'invitacion-webinar', //En Roma...haz como los romanos...
  },
  {
    path: '/invitacion-webinar-2',
    component: InvitacionWebInarBis,
    name: 'invitacion-webinar',
  },
  {
    path: translations.enlaces.quienes_somos,
    component: QuienesSomos
  },
  {
    path: es.kit_digital,
    component: kitDigital
  },
  {
    path: en.kit_digital,
    component: kitDigital
  },
  {
    path: it.kit_digital,
    component: kitDigital
  },

  {
    path: es.servicios,
    component: Productos
  },
  {
    path: en.servicios,
    component: Productos
  },
  {
    path: it.servicios,
    component: Productos
  },

  {
    path: `${es.servicios}/:id`,
    component: ProductoFicha,
    props: true,
    meta: {
      title: 'servicios_values.:id',
      description: "Un gran número de clientes avalan nuestra experiencia. Descubre lo que Iformalia ha hecho por sus organizaciones."
    }
  },
  {
    path: `${en.servicios}/:id`,
    component: ProductoFicha
  },
  {
    path: `${it.servicios}/:id`,
    component: ProductoFicha
  },
  {
    path: it.demoRichiedi,
    component: demoRichiedi,
    name:'demoIt',
  },
  {
    path: es.test,
    component: test,
    name:'test',
  },
  {
    path: es.clientes,
    component: Clientes
  },
  {
    path: en.clientes,
    component: Clientes
  },
  {
    path: it.clientes,
    component: Clientes
  },

  {
    path: es.contacto,
    component: Contacto,
    meta: {
      title: "Iformalia| Contacto Solicita tu Demo",
      description: "¿Quieres contactar con nosotros o solicitar una demo? Hazlo a través de nuestro formulario o llamando al 911427887."
    }
  },
  {
    path: en.contacto,
    component: Contacto
  },
  {
    path: it.contacto,
    component: Contacto
  },


  {
    path: es.features,
    component: features
  },
  {
    path: es.blog,
    component: blog
  },
  {
    path: `${es.blog}/:id?`,
    component: fichaBlog
  },
  {
    path: es.ebooks,
    component: ebooks
  },
  {
    path: es.medios,
    component: medios
  },
  {
    path: es.casosExito,
    component: casosExito
  },
 
  {
    path: es.sala_de_prensa,
    component: Saladeprensa
  },
  {
    path: en.sala_de_prensa,
    component: Saladeprensa
  },
  {
    path: it.sala_de_prensa,
    component: Saladeprensa
  },

  {
    path: es.politica_privacidad,
    component: politicaPrivacidad
  },
  {
    path: en.politica_privacidad,
    component: politicaPrivacidad
  },
  {
    path: it.politica_privacidad,
    component: politicaPrivacidad
  },

  {
    path: es.politica_cookies,
    component: politicaCookies
  },
  {
    path: en.politica_cookies,
    component: politicaCookies
  },
  {
    path: it.politica_cookies,
    component: politicaCookies
  }, {
    path: es.aviso_legal,
    component: avisoLegal,
  },
  {
    path: '*',
    redirect: '/404'
  },
  {
    path: "/404",
    component: Error404
  }
  ],
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return {
        x: 0,
        y: 0
      }
    }
  },
})



router.beforeEach((to, from, next) => {

  //Obtenemos las traducciones de es>enlaces>servicios.empresa
  let translation = es;
  let string = to.meta.title;
  //buscamos donde ponga :id
  let regex = new RegExp(":([a-z]*)");
  let array = regex.exec(string);

  if (!!to.meta.title) {

    if (array) {

      array.shift();
      array.forEach(function (r) {
        let value = to.params[r] // to.params.id; obtenemos el valor de :id (empres, centro de formacion etc)
        string = string.replace(":" + r, value); //remplazamos :id por el valor es decir, empresa
      });
      string.split('.').every(function (r) {
        translation = translation[r];
        return translation; //devolvemos lo que contiene la traducción de cada :id en el json de translations
      });
      document.title = translation['title'];


    } else {
      document.title = to.meta.title;

    }
  }
  if (!!to.meta.description) {
    if (array) {
      document.head.querySelector("[name=description]").content = translation['description'];

    } else {
      document.head.querySelector("[name=description]").content = to.meta.description;
      document.head.querySelector("[property='og:description']").content = to.meta.description;
    }

  }
  next();
});

export default router;


// WEBPACK FOOTER //
// ./src/router/index.js